/* eslint-disable no-console */
// crypto.js

import CryptoJS from 'crypto-js';
const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY || 'hydrokey';

/**
 * Mengenkripsi data (object, array, string, dll) menjadi string terenkripsi.
 * @param {*} data - Data yang akan dienkripsi. Harus bisa di-serialize oleh JSON.stringify.
 * @returns {string|null} - String terenkripsi (Base64) atau null jika terjadi kesalahan.
 */
export const encrypt = data => {
  try {
    // 1. Ubah data apapun menjadi string JSON
    const serializedData = JSON.stringify(data);

    // 2. Enkripsi string JSON tersebut
    const encryptedData = CryptoJS.AES.encrypt(
      serializedData,
      SECRET_KEY
    ).toString();

    return encryptedData;
  } catch (error) {
    console.error('Enkripsi gagal:', error);
    return null;
  }
};

/**
 * Mendekripsi string terenkripsi kembali ke data aslinya.
 * @param {string} encryptedData - String terenkripsi yang akan didekripsi.
 * @returns {*|null} - Data asli (object, array, dll) atau null jika terjadi kesalahan.
 */
export const decrypt = encryptedData => {
  try {
    if (!encryptedData) {
      return null;
    }
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedData) {
      return null;
    }
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Dekripsi gagal:', error);
    // Bisa jadi data bukan JSON atau kunci salah
    return null;
  }
};

export const encryptAuthUser = authUser => {
  const authUserString = JSON.stringify(authUser);
  const encrypted = CryptoJS.AES.encrypt(authUserString, SECRET_KEY).toString();
  return encrypted;
};

export const decryptAuthUser = encryptedData => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};

export const PersistDecrypt = encryptedData => {
  try {
    if (
      typeof encryptedData === 'string' &&
      encryptedData.includes('U2FsdGVkX1')
    ) {
      console.log('🔓 Manual decrypting...');
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted ? JSON.parse(decrypted) : null;
    }
    // Jika tidak terenkripsi, parse sebagai JSON biasa
    return typeof encryptedData === 'string'
      ? JSON.parse(encryptedData)
      : encryptedData;
  } catch (error) {
    console.error('❌ Manual decryption error:', error);
    return null;
  }
};

export const quickDecrypt = encryptedValue => {
  try {
    // Remove all layers of quotes
    let clean = encryptedValue;
    while (
      clean &&
      typeof clean === 'string' &&
      clean.startsWith('"') &&
      clean.endsWith('"')
    ) {
      clean = JSON.parse(clean);
    }

    // Decrypt if it's encrypted
    if (clean && clean.includes('U2FsdGVkX1')) {
      const bytes = CryptoJS.AES.decrypt(clean, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted ? JSON.parse(decrypted) : null;
    }

    return clean ? JSON.parse(clean) : null;
  } catch (error) {
    console.error('Quick decrypt error:', error);
    return null;
  }
};
